import { FilePicker } from 'components/Profile';
import Heading from './Heading';

const CardPhotos = ({ onTypeInstead }) => (
  <>
    <Heading
      title="Snap the front of your card"
      description="A clear photo of the front is all we need. The back helps if your plan lists a claims address."
    />

    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <FilePicker name="card_front_pic" placeholder="Front of card" hint="Required" />
      <FilePicker name="card_back_pic" placeholder="Back of card" hint="Optional" />
    </div>

    <button
      type="button"
      onClick={onTypeInstead}
      className="text-[13px] font-semibold text-secondary-600 underline underline-offset-4 transition-colors hover:text-secondary-900"
    >
      Type the details instead
    </button>
  </>
);

export default CardPhotos;
